import { Fragment, useEffect } from "react";

import { prop, define, useCraftProp } from "@/components/builder/utils";
import { useUtilities } from "@/modules/cms/views/post/components/builder/context";

import BasePreview from "../../base";

function useSpinnerLoading(spinnerLoading) {
  const { utilitiesParsed } = useUtilities()
  const { setValue: setBackground } = useCraftProp('background.image')
  const { setValue: setSizeWidth } = useCraftProp('size.width')
  const { setValue: setAnimation } = useCraftProp('animation')

  useEffect(() => {
    if (spinnerLoading && !utilitiesParsed) {
      setBackground({
        src: 'https://dpe-userenroll-assets.s3.amazonaws.com/1761934077162',
        name: 'goiabada2.svg',
        repeat: 'bg-no-repeat',
        position: 'bg-center',
      }, null, ['after'])
      setSizeWidth('w-20', null, ['after'])
      setAnimation([{
        ease: "linear",
        name: "spin",
        loops: "infinite",
        duration: 1000,
      }], null, ['after'])
    }
    if (!spinnerLoading && !utilitiesParsed) {
      setBackground(null, null, ['after'])
      setSizeWidth(null, null, ['after'])
      setAnimation(null, null, ['after'])
    }
  }, [spinnerLoading, setBackground, setSizeWidth, setAnimation, utilitiesParsed])
}

function FormContinueButtonPreview({ label, ...props }) {
  useSpinnerLoading(props?.properties?.spinnerLoading)

  return <BasePreview {...props}>
    <button type="button" >{label}</button>
  </BasePreview>
}

export default define('form-continue-button', FormContinueButtonPreview, Fragment)
  .shared(prop.share('FormContinueButton', 'form-continue-button'))
  .property(prop.predefined.customClass())
  .property(prop.predefined.content().category('standard'))
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .property(prop.switch(<>Spinner <br /> Loading</>, 'spinnerLoading')
    .category('default')
    .ignoreDevice(true))
  .defaultProps({
    spinnerLoading: false,
    background: { color: 'blue-500' },
    textAlign: {
      horizontal: 'center',
    },
    size: {
      width: 'w-full',
    },
    textColor: 'gray-100',
    space: {
      padding: 'pt-2 pb-2 pl-3 pr-3',
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()

